import { env } from '@/config/env';

export const getTenant = (): string => env.TENANT || '';
